// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckIssuesPage_container__MWWoN"};